import React from "react";
import ClientModule from '@gqlapp/module-client-react';
import Route from "@lib/Route";
import resources from './locales/index.js';
import PageNotFound from './PageNotFound';
import {defaultRoute, getProps} from "./config";

export default new ClientModule({
  route:{
    PageNotFound: <Route {...getProps(defaultRoute, PageNotFound, { classNameOnPage: 'page-not-found' })} />
  },
  localization: [{ ns: '404', resources, more: ['common'] }]
});
